const FREE = "free"
const STARTER = "starter"
const GROWTH = "growth"
const ADVANCED = "advanced"
const ULTIMATE = "ultimate"

const plans = [FREE, STARTER, GROWTH, ADVANCED, ULTIMATE]

const planPrices = {
  free: {
    MONTHLY: { gb: 0, eu: 0, us: 0, la: 0 },
    ANNUAL: { gb: 0, eu: 0, us: 0, la: 0 },
  },
  starter: {
    MONTHLY: { gb: 18, eu: 19, us: 22, la: 11 },
    ANNUAL: { gb: 14, eu: 15, us: 18, la: 9 },
  },
  growth: {
    MONTHLY: { gb: 34, eu: 40, us: 40, la: 20 },
    ANNUAL: { gb: 27, eu: 28, us: 36, la: 18 },
  },
  advanced: {
    MONTHLY: { gb: 52, eu: 60, us: 60, la: 30 },
    ANNUAL: { gb: 42, eu: 49, us: 54, la: 27 },
  },
  ultimate: {
    MONTHLY: { gb: 75, eu: 75, us: 75, la: 75 },
    ANNUAL: { gb: 60, eu: 68, us: 72, la: 72 },
  },
}

const regionCurrencyMap = {
  GB: { currency: "£", key: "gb" },
  US: { currency: "US$", key: "us" },
  EU: { currency: "€", key: "eu" },
  LA: { currency: "US$", key: "la" },
}

/*
  Discount is given as a percentage in the PlanColumns component
  and is used on partner pages offering special deals.
*/
const calculatedDiscountPrice = (price, discount) => {
  const discountedPrice = price * (1 - discount / 100)
  return discountedPrice.toFixed(Number.isInteger(discountedPrice) ? 0 : 2)
}

const getPriceAndCurrency = (tier, frequency, region, discount) => {
  const { currency, key } = regionCurrencyMap[region] || {}
  const price = planPrices[tier]?.[frequency]?.[key] || null

  const discountedPrice = calculatedDiscountPrice(price, discount)

  return { price, currency, discountedPrice }
}

/*
  Calculate the saving gained switching from monthly to annual
  billing for each plan, for the given region.
  Return the highest saving as a rounded percentage.
*/
const maxAnnualDiscountForRegion = region => {
  const lowerCaseRegion = region.toLowerCase()

  const paidPlanPrices = plans
    .filter(plan => plan !== FREE)
    .map(plan => planPrices[plan])

  const planDiscounts = paidPlanPrices.map(
    plan =>
      1 - plan["ANNUAL"][lowerCaseRegion] / plan["MONTHLY"][lowerCaseRegion],
  )

  return Math.round(Math.max(...planDiscounts) * 100)
}

module.exports = {
  getPriceAndCurrency,
  maxAnnualDiscountForRegion,
  planPrices,
  plans,
}
